import { CourseTopicData } from "../../models/courseData";

/**
 * Represents the state for course topics in the Redux store.
 */
export interface CourseTopicState {
  courseTopics: CourseTopicData[];
  isLoading: boolean;
  courseTopicsLoaded: boolean;
  error: boolean;
}

/**
 * Action type dispatched when course topic request starts.
 */
export const COURSE_TOPICS_REQUEST = "COURSE_TOPICS_REQUEST";

/**
 * Action type dispatched when course topics are successfully fetched.
 */
export const COURSE_TOPICS_SUCCESS = "COURSE_TOPICS_SUCCESS";

/**
 * Action type dispatched when there is an error fetching course topics.
 */
export const COURSE_TOPICS_FAILURE = "COURSE_TOPICS_FAILURE";

/**
 * Action for initiating a course topic fetch request.
 */
export interface CourseTopicsRequestAction {
  type: typeof COURSE_TOPICS_REQUEST;
}

/**
 * Action for handling a failed course topic fetch request.
 */
export interface CourseTopicsFailureAction {
  type: typeof COURSE_TOPICS_FAILURE;
}

/**
 * Action for handling a successful course topic fetch.
 */
export interface CourseTopicsSuccessAction {
  type: typeof COURSE_TOPICS_SUCCESS;
  data: CourseTopicData[];
}

/**
 * Union type for all possible course topic action types.
 */
export type CourseTopicActionTypes =
  | CourseTopicsRequestAction
  | CourseTopicsSuccessAction
  | CourseTopicsFailureAction;
